import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useFunnelStore } from "@/store/funnel";
import { takeUpMission } from "@/features/funnel/hooks/use-phone-login";
import { queryClient } from "@/app/query-client";
import "./beta.css";
type Entry = {
  memberId: number;
  username: string;
  sessionId: string;
  completed: number;
  step: string;
  mission: Parameters<typeof takeUpMission>[0] | null;
};
export function BetaEntry() {
  const pending = useRef<Promise<Entry> | null>(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let live = true;
    const fragment = window.location.hash.slice(1);
    const token = fragment.startsWith("invite=")
      ? new URLSearchParams(fragment).get("invite")
      : fragment;
    // ponytail: sync bail-out before async work — no async alternative for an early return
    /* eslint-disable react-hooks/set-state-in-effect */
    if (!token) {
      setError("Open the private beta invitation you were given.");
      return;
    }
    /* eslint-enable react-hooks/set-state-in-effect */
    if (!pending.current)
      pending.current = axios
        .post(
          "/api/secretmissions/beta/entry/",
          { token },
          { withCredentials: true },
        )
        .then((r) => r.data.result);
    pending.current
      .then(async (data) => {
        if (!live) return;
        await queryClient.cancelQueries();
        if (!live) return; // re-check after async gap
        queryClient.clear();
        for (const key of [
          "secret-missions-stepper",
          "secret-missions-funnel",
          "secret-missions-chat-drafts",
          "secret-missions-ref",
          "secret-missions-op",
          "secret-missions-dev-mission",
          "secret-missions-query-cache",
        ])
          localStorage.removeItem(key);
        useFunnelStore.getState().resetFunnel();
        if (data.mission) takeUpMission(data.mission);
        localStorage.setItem("goodglows_sessionid", data.sessionId);
        localStorage.setItem("secret-missions-known", "1");
        const go = data.step !== "Not started" ? data.step : "Start";
        window.location.replace(`/?go=${encodeURIComponent(go)}`);
      })
      .catch((e) => {
        if (live)
          setError(
            axios.isAxiosError(e)
              ? e.response?.data?.message ||
                  "Could not open your beta invitation."
              : "Could not open your beta invitation.",
          );
      });
    return () => {
      live = false;
    };
  }, []);
  return (
    <main className="beta-page">
      <section className="beta-entry">
        {error ? (
          <p role="alert" className="beta-error">
            {error}
          </p>
        ) : (
          <p role="status">Opening your invitation…</p>
        )}
      </section>
    </main>
  );
}
